(() => {
  if (window.LH_CART_UPSELL_GROUP_LOADED) {
    return;
  }

  window.LH_CART_UPSELL_GROUP_LOADED = true;

  class LHCartUpsell extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.viewport = this.querySelector('[data-lh-upsell-viewport]');
      this.grid = this.querySelector('[data-lh-upsell-grid]');
      this.refreshButton = this.querySelector('[data-lh-refresh-group]');
      this.prevButton = this.querySelector('[data-lh-prev-group]');
      this.nextButton = this.querySelector('[data-lh-next-group]');
      this.cards = Array.from(this.querySelectorAll('[data-lh-upsell-card]'));

      this.groupIndex = Number(this.dataset.lhGroupIndex || 0);
      this.oldGroupSize = this.getGroupSize();

      this.desktopCount = Number(this.dataset.desktopCount || 3);
      this.mobileCount = Number(this.dataset.mobileCount || 2);
      this.cycleGroups = this.dataset.cycleGroups === 'true';
      this.enableDrag = this.dataset.enableDrag === 'true';
      this.isAddingToCart = false;

      if (!this.grid || !this.cards.length) return;

      this.bindSubmitEvent();
      this.bindMiniCartAddEvent();
      this.bindDragEvent();

      this.renderGroup(false);
      this.classList.add('is-ready');

      if (window.ResizeObserver) {
        this.resizeObserver = new ResizeObserver(() => {
          clearTimeout(this.resizeTimer);

          this.resizeTimer = setTimeout(() => {
            this.handleResize();
          }, 120);
        });

        this.resizeObserver.observe(this);
      } else {
        this.boundResizeHandler = () => {
          clearTimeout(this.resizeTimer);

          this.resizeTimer = setTimeout(() => {
            this.handleResize();
          }, 120);
        };

        window.addEventListener('resize', this.boundResizeHandler);
      }

      this.initialized = true;
    }
    bindMiniCartAddEvent() {
      this.addEventListener('click', async event => {
        const button = event.target.closest('[data-lh-mini-cart-add-to-cart]');

        if (!button) return;

        event.preventDefault();
        event.stopPropagation();

        if (this.isAddingToCart) return;

        const variantId = button.dataset.variantId;

        if (!variantId) return;

        const icon = button.querySelector('[data-lh-add-icon]');
        const originalIcon = icon ? icon.innerHTML : '';

        this.isAddingToCart = true;

        button.disabled = true;
        button.classList.remove('is-added', 'is-error');
        button.classList.add('is-loading');

        if (icon) {
          icon.textContent = '…';
        }

        try {
          const response = await fetch(
            `${window.Shopify.routes.root}cart/add.js`,
            {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
              },
              body: JSON.stringify({
                items: [
                  {
                    id: Number(variantId),
                    quantity: 1
                  }
                ]
              })
            }
          );

          if (!response.ok) {
            throw new Error('Add to cart failed');
          }

          await response.json();

          button.classList.remove('is-loading');
          button.classList.add('is-added');

          if (icon) {
            icon.textContent = '✓';
          }

          document.documentElement.dispatchEvent(
            new CustomEvent('cart:refresh', {
              bubbles: true
            })
          );

          window.setTimeout(() => {
            button.classList.remove('is-added');

            if (icon) {
              icon.innerHTML = originalIcon;
            }
          }, 1000);
        } catch (error) {
          console.error('[LH Cart Upsell]', error);

          button.classList.remove('is-loading');
          button.classList.add('is-error');

          if (icon) {
            icon.textContent = '!';
          }

          window.setTimeout(() => {
            button.classList.remove('is-error');

            if (icon) {
              icon.innerHTML = originalIcon;
            }
          }, 1200);
        } finally {
          button.disabled = false;
          this.isAddingToCart = false;
        }
      });
    }
    disconnectedCallback() {
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
      }

      if (this.boundResizeHandler) {
        window.removeEventListener('resize', this.boundResizeHandler);
      }

      if (this.boundPointerUpHandler) {
        window.removeEventListener('pointerup', this.boundPointerUpHandler);
        window.removeEventListener('pointercancel', this.boundPointerUpHandler);
      }
    }

    getGroupSize() {
      return window.innerWidth < 768
        ? Number(this.dataset.mobileCount || 2)
        : Number(this.dataset.desktopCount || 3);
    }

    getCards() {
      this.cards = Array.from(this.querySelectorAll('[data-lh-upsell-card]'));
      return this.cards;
    }

    getGroupCount() {
      const cards = this.getCards();
      return Math.ceil(cards.length / this.getGroupSize());
    }

    bindSubmitEvent() {
      this.addEventListener('submit', event => {
        const form = event.target.closest('[data-lh-add-to-cart-form]');
        if (!form) return;

        if (this.isAddingToCart) {
          event.preventDefault();
          return;
        }

        this.isAddingToCart = true;

        const button = form.querySelector('[data-lh-add-to-cart]');
        const icon = button ? button.querySelector('[data-lh-add-icon]') : null;
        const allAddButtons = Array.from(this.querySelectorAll('[data-lh-add-to-cart]'));

        if (button) {
          button.classList.remove('is-added', 'is-error');
          button.classList.add('is-loading');
        }

        allAddButtons.forEach(btn => {
          btn.disabled = true;
        });

        if (icon) {
          icon.textContent = '…';
        }

        // reload 模式下不 preventDefault，让 Shopify 原生提交
      });
    }

    bindDragEvent() {
      if (!this.enableDrag || !this.viewport) return;

      this.viewport.addEventListener('pointerdown', event => {
        this.onPointerDown(event);
      });

      this.boundPointerUpHandler = event => {
        this.onPointerUp(event);
      };

      window.addEventListener('pointerup', this.boundPointerUpHandler);
      window.addEventListener('pointercancel', this.boundPointerUpHandler);
    }

    handleResize() {
      const newGroupSize = this.getGroupSize();

      if (newGroupSize === this.oldGroupSize) return;

      const firstVisibleIndex = this.groupIndex * this.oldGroupSize;

      this.groupIndex = Math.floor(firstVisibleIndex / newGroupSize);
      this.oldGroupSize = newGroupSize;

      this.renderGroup(false);
    }

    renderGroup(animate = true) {
      const cards = this.getCards();
      const groupSize = this.getGroupSize();
      const groupCount = this.getGroupCount();

      if (!cards.length) return;

      this.groupIndex = Math.max(
        0,
        Math.min(this.groupIndex, Math.max(groupCount - 1, 0))
      );

      this.dataset.lhGroupIndex = String(this.groupIndex);

      const start = this.groupIndex * groupSize;
      const end = start + groupSize;

      this.style.setProperty('--lh-upsell-columns', String(groupSize));

      const update = () => {
        cards.forEach((card, index) => {
          card.hidden = !(index >= start && index < end);
        });

        this.updateButton();
      };

      if (!animate) {
        update();
        return;
      }

      this.classList.add('is-changing');

      window.setTimeout(() => {
        update();

        window.setTimeout(() => {
          this.classList.remove('is-changing');
        }, 30);
      }, 120);
    }

    updateButton() {
      const groupCount = this.getGroupCount();

      const hasMultipleGroups = groupCount > 1;
      const isFirstGroup = this.groupIndex <= 0;
      const isLastGroup = this.groupIndex >= groupCount - 1;

      if (this.refreshButton) {
        this.refreshButton.disabled = !hasMultipleGroups;
      }

      if (this.prevButton) {
        this.prevButton.disabled = !hasMultipleGroups;
        this.prevButton.classList.toggle('is-edge', isFirstGroup);
      }

      if (this.nextButton) {
        this.nextButton.disabled = !hasMultipleGroups;
        this.nextButton.classList.toggle('is-edge', isLastGroup);
      }
    }

    nextGroup() {
      const groupCount = this.getGroupCount();

      if (groupCount <= 1) return;

      if (this.groupIndex < groupCount - 1) {
        this.groupIndex += 1;
      } else if (this.cycleGroups) {
        this.groupIndex = 0;
      }

      this.renderGroup(true);
    }

    prevGroup() {
      const groupCount = this.getGroupCount();

      if (groupCount <= 1) return;

      if (this.groupIndex > 0) {
        this.groupIndex -= 1;
      } else if (this.cycleGroups) {
        this.groupIndex = groupCount - 1;
      }

      this.renderGroup(true);
    }

    onPointerDown(event) {
      if (event.button !== undefined && event.button !== 0) return;
      if (event.target.closest('button, a, input, select, textarea')) return;

      this.dragStartX = event.clientX;
      this.dragStartY = event.clientY;
      this.isDragging = true;

      this.classList.add('is-dragging');
    }

    onPointerUp(event) {
      if (!this.isDragging) return;

      const diffX = event.clientX - this.dragStartX;
      const diffY = event.clientY - this.dragStartY;

      this.isDragging = false;
      this.classList.remove('is-dragging');

      if (Math.abs(diffX) < 45 || Math.abs(diffX) < Math.abs(diffY)) {
        return;
      }

      if (diffX < 0) {
        this.nextGroup();
      } else {
        this.prevGroup();
      }
    }
  }

  if (!customElements.get('lh-cart-upsell')) {
    customElements.define('lh-cart-upsell', LHCartUpsell);
  }

  function initUpsells() {
    document.querySelectorAll('lh-cart-upsell').forEach(element => {
      if (!element.initialized && typeof element.connectedCallback === 'function') {
        element.connectedCallback();
      }
    });
  }

  /**
   * 关键：事件委托。
   * 不管按钮是不是后面被 Ajax 插入的，都能点击切换。
   */
  document.addEventListener('click', event => {
    const prevButton = event.target.closest('[data-lh-prev-group]');
    const nextButton = event.target.closest('[data-lh-next-group]');
    const refreshButton = event.target.closest('[data-lh-refresh-group]');

    if (!prevButton && !nextButton && !refreshButton) return;

    const upsell = event.target.closest('lh-cart-upsell');
    if (!upsell) return;

    event.preventDefault();
    event.stopPropagation();

    if (!upsell.initialized && typeof upsell.connectedCallback === 'function') {
      upsell.connectedCallback();
    }

    if (prevButton && typeof upsell.prevGroup === 'function') {
      upsell.prevGroup();
    }

    if ((nextButton || refreshButton) && typeof upsell.nextGroup === 'function') {
      upsell.nextGroup();
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initUpsells);
  } else {
    initUpsells();
  }

  document.addEventListener('shopify:section:load', initUpsells);
})();